import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { devicesApi } from '@/api/index';
import type { TGetFilters } from '@/api/routes/devices/types';

export const fetchDevicesFilters = createAsyncThunk(
  'devicesFilters',
  async (params: TGetFilters, thunkAPI) => {
    try {
      const response = await devicesApi.getFilters(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
